import { render, staticRenderFns } from "./succeed.vue?vue&type=template&id=3dd283ae&scoped=true&"
import script from "./succeed.vue?vue&type=script&lang=js&"
export * from "./succeed.vue?vue&type=script&lang=js&"
import style0 from "./succeed.vue?vue&type=style&index=0&id=3dd283ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd283ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd283ae')) {
      api.createRecord('3dd283ae', component.options)
    } else {
      api.reload('3dd283ae', component.options)
    }
    module.hot.accept("./succeed.vue?vue&type=template&id=3dd283ae&scoped=true&", function () {
      api.rerender('3dd283ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/myComplain/succeed.vue"
export default component.exports